import { render, staticRenderFns } from "./TeacherDashboardIndex.vue?vue&type=template&id=316c2252"
import script from "./TeacherDashboardIndex.js?vue&type=script&lang=js&external"
export * from "./TeacherDashboardIndex.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports